import * as Yup from 'yup';

export const connectBankFormValidationSchema = Yup.object().shape({
  bankNickname: Yup.string()
    .required('Bank Nickname is Required')
    .min(2, 'Must be at least 2 characters')
    .max(20, 'Must be no more than 20 characters'),
  routingNumber: Yup.string()
    .required('Routing Number is Required')
    .matches(/^[0-9]+$/, 'Must be only digits')
    .min(2, 'Must be at least 2 numbers')
    .max(30, 'Must be no more than 30 numbers'),
  accountNumber: Yup.string()
    .required('Account Number is Required')
    .matches(/^[0-9]+$/, 'Must be only digits')
    .min(2, 'Must be at least 2 numbers')
    .max(30, 'Must be no more than 30 numbers'),
  confirmAccountNumber: Yup.string()
    .required('Confirm Account Number is Required')
    .oneOf([Yup.ref('accountNumber'), null], 'Account Numbers must match'),
});
